"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCancellationPolicyDescription = void 0;

var _localization = require("@lt/localization");

var _date = require("../../../utils/date");

var getCancellationPolicyDescription = function getCancellationPolicyDescription(returnType, endDate) {
  if (returnType === 'full') return "".concat(_localization.i18n.t('cancellationPolicy.tariff.before'), " ").concat((0, _date.formatDate)(endDate, 'd MMM, HH:mm'));
  if (returnType === 'nothing') return _localization.i18n.t('cancellationPolicy.tariff.nothing');
  if (returnType === 'partial') return _localization.i18n.t('cancellationPolicy.tariff.partial');
  return '';
};

exports.getCancellationPolicyDescription = getCancellationPolicyDescription;